function a(n) {
  return r(`/hae-toimitilaa/premise?id=${n}`);
}
function r(n) {
  if (typeof window > "u")
    return n;
  const e = new URL(window.location.origin), i = window.location.pathname.split("/").find(
    (t) => t.length === 5 && t.includes("-")
  );
  return i ? new URL(`/${i}${n}`, e).toString() : new URL(n, e).toString();
}
export {
  a as g
};
